import React from 'react';
import { map, find, get, size, noop, isEmpty } from 'lodash';

// Local Dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';
import { widgetNoData as WidgetNoData } from 'ui/views/widgets/widgetNoData';
import classnames from 'classnames';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberHealthConditions as MemberHealthConditions } from 'ui/views/widgets/memberHealthConditions';
 *
 * // render
 * <MemberHealthConditions propName='propValue'/>
 */
export const memberHealthConditionsSuccess = ( props ) => {

    // extracting edit Action
    const editAction = find( props.action, { name: 'edit' } );

    const { visibility = {} } = props;

    // check action visibility
    const isEditActionActive = ! isEmpty( editAction ) ? get( visibility, `${editAction.visibility}`, false ): false;

    const actionClassName = classnames( 'ui-member-health-conditions__edit__button', {
        'ui-member-health-conditions__edit__button--disabled': ! isEditActionActive
    } );
    
    //const { showCustomErrorView = false, description, noDataView } = props;

    // if( 0 === size( props.data ) || showCustomErrorView ) {
    // 	return (
    // 		<div className="ui-member-health-conditions-info-default">
    // 			<div className='ui-member-health-conditions-info-default__icon'>
    //                 <Icon name='warningBlue' width={ 50 } height={ 50 } />
    //             </div>

    // 			{/* sub-title */}
    //             <p className='ui-member-health-conditions-info-default__title'>
    //                 { showCustomErrorView ? description: getLabel( get( noDataView, 'message', {} ) ) }
    //             </p>

    // 	</div>
    // 	);
    // }
    
    return (
        <div className='ui-member-health-conditions'>

            {/* action */}
            <div className='ui-member-health-conditions__edit' >
                <div className={ actionClassName }  onClick={ () => isEditActionActive ? props.onClickEdit( { action: editAction } ) : noop }>
                    <div className='ui-member-health-conditions__edit__button__icon'> <Icon name='edit' fill={ isEditActionActive ? THEME.themeColorPrimary2 : '#7a7a7a' } /> </div>
                    <div className='ui-member-health-conditions__edit__button__title'>{ getLabel( get( editAction, 'title', {} ) ) }</div>
                </div>
            </div>

            {/* data */}
            {
                0 === size( props.data ) ? (
                    <div className='ui-member-health-conditions__no-data'>
                        <WidgetNoData
                          message={ props.memberData.isHealthConditionsNotAtVerified? get( props.noDataView, 'message2', null ): get( props.noDataView, 'message', null ) }
                        />
                    </div>
                ) : (
                    <div className='ui-member-health-conditions__conditions'>
                        { map( ( props.data ), field => {
                            return (
                                <div key={ field.id } className='ui-member-health-conditions__conditions__condition'> { field.name } </div>
                            );
                        } ) }
                    </div>
                )
            }
        </div>
    );
   
};

// set display name
memberHealthConditionsSuccess.displayName = 'memberHealthConditionsSuccess';

// set default props
memberHealthConditionsSuccess.defaultProps = {};

// prop types
memberHealthConditionsSuccess.propTypes = {};

//  preloader view
export const memberHealthConditionsPreloader = ( ) => {
    return (
         <div className='ui-member-health-conditions-preloader'>
         {
             map( [ 1, 2, 3, 4, 5 ], item => {
                 return (
                     <div key={ item } className='ui-member-health-conditions-preloader__item'/>
                 );
             } )
         }
     </div>
    );
};

// set display name
memberHealthConditionsPreloader.displayName = 'memberHealthConditionsPreloader';

// set default props
memberHealthConditionsPreloader.defaultProps = {};

// prop types
memberHealthConditionsPreloader.propTypes = {};

export const memberHealthConditions = withNetworkState( memberHealthConditionsPreloader, memberHealthConditionsSuccess );
